/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, utils } from "ethers";
const _abi = [
    {
        type: "function",
        name: "getPositionData",
        inputs: [
            {
                name: "tokenId",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [
            {
                name: "",
                type: "tuple",
                internalType: "struct IUniswapV3DataProvider.PositionData",
                components: [
                    {
                        name: "tokenId",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "token0",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "token1",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "fee",
                        type: "uint24",
                        internalType: "uint24",
                    },
                    {
                        name: "tickLower",
                        type: "int24",
                        internalType: "int24",
                    },
                    {
                        name: "tickCurrent",
                        type: "int24",
                        internalType: "int24",
                    },
                    {
                        name: "tickUpper",
                        type: "int24",
                        internalType: "int24",
                    },
                    {
                        name: "sqrtPriceX96",
                        type: "uint160",
                        internalType: "uint160",
                    },
                    {
                        name: "amount0",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount1",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "fee0",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "fee1",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "liquidity",
                        type: "uint128",
                        internalType: "uint128",
                    },
                ],
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "getPositionsData",
        inputs: [
            {
                name: "tokenIds",
                type: "uint256[]",
                internalType: "uint256[]",
            },
        ],
        outputs: [
            {
                name: "datas",
                type: "tuple[]",
                internalType: "struct IUniswapV3DataProvider.PositionData[]",
                components: [
                    {
                        name: "tokenId",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "token0",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "token1",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "fee",
                        type: "uint24",
                        internalType: "uint24",
                    },
                    {
                        name: "tickLower",
                        type: "int24",
                        internalType: "int24",
                    },
                    {
                        name: "tickCurrent",
                        type: "int24",
                        internalType: "int24",
                    },
                    {
                        name: "tickUpper",
                        type: "int24",
                        internalType: "int24",
                    },
                    {
                        name: "sqrtPriceX96",
                        type: "uint160",
                        internalType: "uint160",
                    },
                    {
                        name: "amount0",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount1",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "fee0",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "fee1",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "liquidity",
                        type: "uint128",
                        internalType: "uint128",
                    },
                ],
            },
        ],
        stateMutability: "view",
    },
];
export class IUniswapV3DataProvider__factory {
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
IUniswapV3DataProvider__factory.abi = _abi;
//# sourceMappingURL=IUniswapV3DataProvider__factory.js.map